export var ResourceType;
(function (ResourceType) {
    ResourceType["OBJECTS"] = "objects";
    ResourceType["PLACES"] = "places";
})(ResourceType || (ResourceType = {}));
